export const dynamicTranslateKeys: Record<
  number,
  {
    key: string;
    text: string;
  }
> = {
  1000: {
    key: 'customBadResponse',
    text: 'Xatolik mavjud'
  },
  1301: {
    key: 'flatInvalidField',
    text: "Xonadon bilan bog'liq xatolik, raqami: {{&flatNumber&}}  , parametr: {{&field&}}"
  },
  1001: {
    key: 'contractHasOwner',
    text: 'Shartnoma ushbu mijozga tegishli: {{&clientName&}}.'
  },
  1002: {
    key: 'discountAlreadyExists',
    text: 'Bunday nomdagi chegirma mavjud: {{&name&}}'
  },
  1003: {
    key: 'discountCalculationError',
    text: "Boshlang'ich to'lov ({{&paymentPercent&}}%) va chegirma foizi ({{&discountPercent&}}%) mos kelmadi. Iltimos xatolikni tuzatib keyin saqlang!"
  },
  1004: {
    key: 'monthlyPaymentsSum',
    text: "Oylik to'lovlar summasi to'g'ri emas: {{&amount&}}"
  },
  1005: {
    key: 'contractFieldOptionAlreadyExists',
    text: "Shartnoma o'zgaruvchisi qiymati mavjud!"
  },
  1006: {
    key: 'contractFieldOptionNotFound',
    text: "Shartnoma o'zgaruvchi qiymati topilmadi!"
  },
  1007: {
    key: 'contractFieldAlreadyExists',
    text: "Shartnoma o'zgaruvchisi mavjud!"
  },
  1008: {
    key: 'contractFieldNotFound',
    text: "Shartnoma o'zgaruvchisi topilmadi!"
  },
  1009: {
    key: 'monthlyPaymentPartNotFound',
    text: "Oylik to'lov qismi topilmadi."
  },
  1010: {
    key: 'monthlyPaymentPrepaymentDateAndContractDateConfilictExc',
    text: "Boshlang'ich to'lov sanasi  shartnoma yaratish sanasidan oldin bo'lishi mumkin emas"
  },
  1011: {
    key: 'monthlyPaymentNotFound',
    text: "Oylik to'lov topilmadi!"
  },
  1012: {
    key: 'contractCreateConflict',
    text: "Shartnoma yaratishda konflikt mavjud. Iltimos, qayta urinib ko'ring!"
  },
  1013: {
    key: 'discountPartNotFound',
    text: 'Chegirma topilmadi.'
  },
  1014: {
    key: 'discountNotFound',
    text: 'Chegirma topilmadi'
  },
  1015: {
    key: 'incorrectDiscountAmount',
    text: "Chegirma summasi noto'g'ri kiritilgan!"
  },
  1016: {
    key: 'contractNotFoundOrInBadState',
    text: 'Shartnoma topilmadi yoki nomaqbul holatda.'
  },
  1017: {
    key: 'contractNotFoundOrAlreadyCancelled',
    text: "Shartnoma topilmadi yoki allaqachon to'xtatilgan."
  },
  1018: {
    key: 'invalidPrepaymentDate',
    text: "Boshlang'ich to'lov kuni xato kiritilgan: {{&prepaymentDate&}}."
  },
  1019: {
    key: 'invalidPrepayment',
    text: "Boshlang'ich to'lov xato kiritilgan: {{&prepayment&}}."
  },
  1020: {
    key: 'contractNotFound',
    text: 'Shartnoma topilmadi.'
  },
  1021: {
    key: 'monthlyPaymentPartDateUnique',
    text: "Ushbu oylik to'lov sanasi takrorlangan: '{{&date&}}'"
  },
  1022: {
    key: 'monthlyPaymentPartDateInvalid',
    text: "Ushbu oylik to'lov sanasi xato kiritilgan: '{{&date&}}'"
  },
  1023: {
    key: 'monthlyPaymentDelayInterval',
    text: "To'lov grafigigi muddati: {{&delay&}}, vaqt oralig'i: {{&interval&}} bilan mutonosib emas"
  },
  1024: {
    key: 'pastDatePayment',
    text: "O'tgan sana to'loviga ruxsat yo'q!"
  },
  1026: {
    key: 'paymentFieldOptionNotFound',
    text: "To'lov o'zgaruvchi qiymati topilmadi!"
  },
  1027: {
    key: 'paymentFieldAlreadyExists',
    text: "To'lov o'zgaruvchisi mavjud!"
  },
  1028: {
    key: 'paymentFieldOptionAlreadyExistsException',
    text: "To'lov o'zgaruvchisi qiymati mavjud!"
  },
  1029: {
    key: 'contractVariationGroupNotFound',
    text: "Shartnoma to'lov takliflari guruhi topilmadi"
  },
  1030: {
    key: 'contractVariationGroupName',
    text: "Shartnoma to'lov takliflari guruhi nomi allaqachon mavjud"
  },
  1031: {
    key: 'contractVariationNotFound',
    text: "Shartnoma to'lov takliflari topilmadi"
  },
  1032: {
    key: 'mortgagePaymentDate',
    text: "Ipotekaga o'tgan kun sanasini biriktirib bo'lmaydi"
  },
  1033: {
    key: 'changePriceExc',
    text: "Shartnoma o'zgarish narxida xatolik!"
  },
  1034: {
    key: 'overallPercentageExc',
    text: "Umumiy foiz 100 % dan kam bo'lmasligi kerak!"
  },
  1035: {
    key: 'notSelectSeveralBranchesException',
    text: 'Bir nechta filialdan kvartira tanlash mumkin emas'
  },
  1036: {
    key: 'contractFinishedException',
    text: 'Shartnoma yakunlangan'
  },
  1037: {
    key: 'currencyNotMatchException',
    text: "Mos bo'lmagan valyuta"
  },
  1038: {
    key: 'contractTemplateNotFoundException',
    text: 'Shartnoma shabloni mavjud emas!'
  },
  1039: {
    key: 'contractCurrencyInvalidException',
    text: 'Shartnoma valyutasi mutanosib emas!'
  },
  1040: {
    key: 'noDebt',
    text: 'Qarzdorliklar mavjud emas'
  },
  1041: {
    key: 'termDiscountExpireDate',
    text: 'Chegirma muddati tugagan!'
  },
  1101: {
    key: 'paymentOutCancel',
    text: "Chiqim to'lovlarini bekor qilib bo'lmaydi!"
  },
  1102: {
    key: 'paymentCanceled',
    text: "To'lov bekor qilingan!"
  },
  1103: {
    key: 'paymentNotFound',
    text: "To'lov topilmadi!"
  },
  1104: {
    key: 'paymentBranchInvalid',
    text: "To'lov boshqa filialda amalga oshirilgan!"
  },
  1105: {
    key: 'paymeServerError',
    text: "Paymeda xatolik. Iltimos qayta urinib ko'ring yoki administratsiyaga murojaat qiling."
  },
  1106: {
    key: 'paymentDateBeforeContract',
    text: "To'lov sanasi shartnoma sanasiga mos emas!"
  },
  1107: {
    key: 'paymentDateAfterNow',
    text: "To'lov sanasi bugungi sanadan katta!"
  },
  1108: {
    key: 'receiptNotFound',
    text: 'Chek topilmadi.'
  },
  1109: {
    key: 'cardNotFound',
    text: 'Karta topilmadi.'
  },
  1110: {
    key: 'cardVerifyCodeIncorrect',
    text: "Noto'g'ri kod."
  },
  1111: {
    key: 'cardVerifyBefore',
    text: 'Karta aktivlashtirilgan.'
  },
  1112: {
    key: 'cardAddedBefore',
    text: 'Karta aktivlashtirilgan.'
  },
  1113: {
    key: 'paymeCashNotFound',
    text: 'Payme Cash topilmadi.'
  },
  1114: {
    key: 'paymeCashPresent',
    text: "Payme Cash oldin yaratilgan. Yangi yaratish uchun eskisini o'chiring."
  },
  1115: {
    key: 'paymentIsBeforeActiveMonthlyPayment',
    text: "To'lov sanasi joriy to'lov grafigiga mutonosib emas!"
  },
  1116: {
    key: 'paymentBaseInvalid',
    text: "To'lov maqsadi ko'rsatilmagan."
  },
  1117: {
    key: 'paymentAmountLarge',
    text: "To'lov miqdori ko'p, summa: {{&amount&}}."
  },
  1118: {
    key: 'priceChangeAmount',
    text: 'Summa xato kiritilgan: {{&amount&}}.'
  },
  1119: {
    key: 'paymentCustomTypeNotFound',
    text: 'PaymentCustomType topilmadi!'
  },
  1120: {
    key: 'paymentCustomTypeIsUsed',
    text: "Bu to'lov turi bilan to'lov qilingan!"
  },
  1121: {
    key: 'paymentCustomTypeLimitReached',
    text: "Limit to'lgan!"
  },
  1122: {
    key: 'incorrectPaymentType',
    text: "To'lov turida xatolik!"
  },
  1201: {
    key: 'uzumCashNotFound',
    text: 'Uzum kassasi topilmadi!'
  },
  1202: {
    key: 'uzumServiceNotFound',
    text: 'Uzum xizmati topilmadi!'
  },
  1203: {
    key: 'houseAlreadyUsedInUzumService',
    text: 'TJM boshqa servisda ishlatilgan!'
  },
  1204: {
    key: 'uzumServiceAlreadyExists',
    text: 'Uzum servisi mavjud!'
  },
  1205: {
    key: 'apiKeyAlreadyUsed',
    text: 'Paylov key allaqachon mavjud'
  },
  1206: {
    key: 'paylovConfigNotFound',
    text: 'Paylov konfiguratsiya topilmadi'
  },
  1207: {
    key: 'paylovServiceProhibited',
    text: 'Paylov tizimidan foydalanish taqiqlandi'
  },
  1208: {
    key: 'paylovCardNotFound',
    text: 'Karta topilmadi'
  },
  1209: {
    key: 'paylovCardExpired',
    text: "Karta muddati o'tgan"
  },
  1210: {
    key: 'paylovInvalidCard',
    text: 'Yaroqsiz karta'
  },
  1211: {
    key: 'myUzcardError',
    text: '{{&message&}}. Kod: {{&code&}}'
  },
  1212: {
    key: 'paylovInvalidOtp',
    text: "Noto'g'ri OTP"
  },
  1213: {
    key: 'paylovBankNotFound',
    text: 'Bank topilmadi'
  },
  1214: {
    key: 'merchantNotAvailable',
    text: 'Savdogar mavjud emas'
  },
  1215: {
    key: 'paylovInvalidAmountException',
    text: 'Yaroqsiz miqdor'
  },
  1216: {
    key: 'transactionNotFoundException',
    text: 'Tranzaksiya topilmadi'
  },
  1217: {
    key: 'cardIsBlockedException',
    text: 'Karta bloklangan'
  },
  1218: {
    key: 'phoneNotMatch',
    text: "Mos bo'lmagan telefon raqam"
  },
  1219: {
    key: 'paylovCardExists',
    text: 'Karta allaqachon mavjud'
  },
  1220: {
    key: 'paylovUnknownException',
    text: "Paylov tizimida xatolik, birozdan song qayta urinib ko'ring"
  },
  1221: {
    key: 'monetaryPaymentAlreadyAcceptException',
    text: "To'lov avval tasdiqlangan!"
  },
  1222: {
    key: 'monetaryPaymentNotAcceptException',
    text: "To'lov tasdiqlanmagan!"
  },
  1223: {
    key: 'monetaryPaymentNotFound',
    text: "To'lov topilmadi!"
  },
  1302: {
    key: 'flatReserved',
    text: 'Xonadon zaxiraga olingan, raqami: {{&flatNumber&}} '
  },
  1303: {
    key: 'flatFieldOptionAlreadyExistsException',
    text: "Xonadon o'zgaruvchisi qiymati mavjud!"
  },
  1304: {
    key: 'flatFieldRequiredException',
    text: "Xonadon o'zgaruvchisi majburiy!"
  },
  1305: {
    key: 'flatFieldAlreadyExists',
    text: "Xonadon o'zgaruvchisi mavjud!"
  },
  1306: {
    key: 'flatFieldNotFound',
    text: "Xonadon o'zgaruvchisi topilmadi!"
  },
  1307: {
    key: 'flatFieldOptionNotFound',
    text: "Xonadon o'zgaruvchi qiymati topilmadi!"
  },
  1308: {
    key: 'flatOptionNotFound',
    text: 'Option Topilmadi!'
  },
  1309: {
    key: 'flatBuildingIdMandatory',
    text: 'Bino identifikatori majburiydir!'
  },
  1310: {
    key: 'flatNotFound',
    text: 'Xonadon topilmadi.'
  },
  1311: {
    key: 'flatAlreadyRepaired',
    text: "Xonadon ta'mirlangan holatda, raqami: {{&number&}}"
  },
  1312: {
    key: 'flatAlreadySold',
    text: 'Xonadon sotilgan, raqami: {{&number&}}'
  },
  1313: {
    key: 'flatStatusUnknown',
    text: "Xonadon statusi noma'lum:  {{&number&}}"
  },
  1314: {
    key: 'flatNotRemovable',
    text: "Xonadonni o'chirib bo'lmaydi, raqami: {{&number&}}"
  },
  1315: {
    key: 'flatOnSale',
    text: 'Uy sotuvda, nomi: {{&name&}}'
  },
  1316: {
    key: 'flatStatusDirectChange',
    text: "Xonadon statusini to'g'ridan to'g'ri o'zgartira olmaysiz, raqami: {{&number&}}"
  },
  1317: {
    key: 'flatLimitReached',
    text: "Xonadon limiti to'lgan! limit: {{&limit&}} , limitdan oshgan xonadonlar: {{&overallFlats&}}"
  },
  1318: {
    key: 'priceRepaired',
    text: 'Xonadon Tamirli 1 m2 narxi kiritilishi kerak!'
  },
  1319: {
    key: 'priceUnRepaired',
    text: 'Xonadon Tamirsiz 1 m2 narxi kiritilishi kerak!'
  },
  1320: {
    key: 'invalidValue',
    text: "Qiymat {{&valueFlat&}} dan katta bo'lishi kerak!"
  },
  1401: {
    key: 'buildingNotFound',
    text: 'Bino topilmadi!'
  },
  1402: {
    key: 'buildingOnSale',
    text: 'Bino sotuvda, iltimos avval uni sotuvdan oling!'
  },
  1403: {
    key: 'buildingAlreadyExist',
    text: "Bitta binoga bir nechta kassa yaratib bo'lmaydi!"
  },
  1501: {
    key: 'houseOnSale',
    text: 'Uy sotuvda, iltimos avval uni sotuvdan oling!'
  },
  1502: {
    key: 'houseFlatInformationConflict',
    text: "TJM xonadon qavat ma'lomotlari kiritilmagan"
  },
  1503: {
    key: 'constructionFloorConflict',
    text: "Qavat noto'g'ri kiritilgan"
  },
  1504: {
    key: 'houseRoofDoesntComplete',
    text: 'TJM tom qismi qurib tugatilmagan'
  },
  1505: {
    key: 'houseNotOnSale',
    text: 'Uy sotuvda emas!'
  },
  1506: {
    key: 'houseNoAccess2Branch',
    text: "Ushbu uy sizning bo'limingizga tegishli emas!"
  },
  1507: {
    key: 'houseNotFound',
    text: 'Uy topilmadi!'
  },
  1601: {
    key: 'builderNotFound',
    text: 'Quruvchi topilmadi!'
  },
  1701: {
    key: 'pipeStatusConflictExc',
    text: 'Voronka shablon yaratishda {{&pipeStatusName&}} statusli pipeLine bir nechta kiritlgan'
  },
  1702: {
    key: 'pipeTemplateNotFoundExc',
    text: 'Voronka shabloni topilmadi'
  },
  1703: {
    key: 'triggerNotFound',
    text: 'Trigger topilmadi'
  },
  1704: {
    key: 'appPipeNotFound',
    text: 'Sahifa voronkasi topilmadi!'
  },
  1705: {
    key: 'leadFormQuestionFieldAlreadyExists',
    text: 'Forma savoli mavjud!'
  },
  1706: {
    key: 'leadFormQuestionFieldNotFound',
    text: 'Forma savoli topilmadi!'
  },
  1707: {
    key: 'leadFormPipeAlreadyExists',
    text: 'Forma mavjud!'
  },
  1708: {
    key: 'leadFormPipeStatusNotFound',
    text: "Bog'langan forma topilmadi!"
  },
  1709: {
    key: 'leadFormNotFound',
    text: 'Lead formasi topilmadi!'
  },
  1710: {
    key: 'facebookPageNotFound',
    text: 'Facebook sahifasi topilmadi!'
  },
  1711: {
    key: 'eventChangeNotFound',
    text: "Eventda o'zgarish topilmadi!"
  },
  1712: {
    key: 'pipeNotFound',
    text: 'Voronka topilmadi!'
  },
  1713: {
    key: 'pipeStatusNotFound',
    text: 'Voronka statusi topilmadi!'
  },
  1714: {
    key: 'tagNotFound',
    text: 'Teg topilmadi!'
  },
  1715: {
    key: 'fieldNotFound',
    text: "O'zgaruvchi topilmadi!"
  },
  1716: {
    key: 'fieldOptionNotFound',
    text: "O'zgaruvchi qiymati topilmadi!"
  },
  1717: {
    key: 'fieldOptionAlreadyExist',
    text: "O'zgaruvchining qiymati mavjud!"
  },
  1718: {
    key: 'fieldAlreadyExist',
    text: "O'zgaruvchi mavjud!"
  },
  1719: {
    key: 'leadNotFound',
    text: 'Lead topilmadi!'
  },
  1720: {
    key: 'onlyLead',
    text: "Birlashtirib bo'lmaydi"
  },
  1721: {
    key: 'salePlanLeadNameExists',
    text: 'Bu nomdagi sotuv rejasi mavjud!'
  },
  1722: {
    key: 'salePlanLeadNotFound',
    text: 'Sotuv rejasi topilmadi!'
  },
  1723: {
    key: 'salePlanLeadTotalAmount',
    text: "Umumiy summa noto'gri kiritilgan!"
  },
  1724: {
    key: 'salePlanLeadTotalCount',
    text: "Ledlar umumiy soni noto'g'ri kiritilgan!"
  },
  1725: {
    key: 'leadAndClientCostNotFound',
    text: 'Lid va Mijoz narxi topilmadi!'
  },
  1726: {
    key: 'leadAndClientCostAlreadyExist',
    text: 'Lid va Mijoz narxi allaqachon mavjud!'
  },
  1727: {
    key: 'tagNameAlreadyExist',
    text: 'Bu nomli Teg allaqachon mavjud!'
  },
  1728: {
    key: 'crmLeadView',
    text: "Bu leadni ko'rishga sizda ruxsat yo'q!"
  },
  1729: {
    key: 'leadFlatBookingLimitReached',
    text: 'Buyurtma qilish chegarasidan oshib ketdi. Max: 10'
  },
  1730: {
    key: 'tagConnotBeDeleted',
    text: "Leadlarda ushbu tag mavjud. O'chirishni imkoni yuq!"
  },
  1731: {
    key: 'pipeCannotBeDeleted',
    text: "Varonkani o'chirish mumkin emas. Ushbu varonkada leadlar mavjud!"
  },
  1732: {
    key: 'UnAvailableAction',
    text: 'Hozirda ushbu amalni bajarishni imkoni mavjud emas!'
  },
  1733: {
    key: 'unAvailableMergeForThisLead',
    text: "Mijoz birlashtirilgan lead larni birlashtirib bo'lmaydi!"
  },
  1734: {
    key: 'countLimitReached',
    text: 'Elementlar soni 5 tadan oshib ketdi!'
  },
  1735: {
    key: 'callNotFound',
    text: "Qo'ng'iroq topilmadi!"
  },
  1736: {
    key: 'callRecordingDownloadException',
    text: "Qo'ng'iroqni yozib olingan fayl ni yuklash imkoni bo'lmadi!"
  },
  1737: {
    key: 'contactNotFound',
    text: 'Kontakt topilmadi!'
  },
  1738: {
    key: 'conversationNotFound',
    text: 'Suhbat topilmadi!'
  },
  1739: {
    key: 'fieldValueTooLarge',
    text: "{{&fieldName&}} ga 1 tadan ko'p qiymat berolmaysiz!"
  },
  1740: {
    key: 'fieldCannotBeDeleted',
    text: "Bu o'zgaruvchi lidlarda ishlatilgan!"
  },
  1741: {
    key: 'fieldExistOnTrigger',
    text: "Bu o'zgaruvchi triggerda ishlatilgan!"
  },
  1742: {
    key: 'leadNoteCannotBeDeleted',
    text: 'Bu eslatmani oʻchirib boʻlmaydi!'
  },
  1743: {
    key: 'leadNoteNotFound',
    text: 'Eslatma topilmadi!'
  },
  1744: {
    key: 'fieldExistOnLeadForm',
    text: "Bu o'zgaruvchi lid formada ishlatilgan!"
  },
  1745: {
    key: 'fieldExistOnExpoPrint',
    text: "Bu o'zgaruvchi expo printda ishlatilgan!"
  },
  1746: {
    key: 'fieldValueNotFilled',
    text: "{{&name&}} ning ma'lumotlari to'ldirilmagan!"
  },
  1747: {
    key: 'clientDoesNotAttachedToThisLead',
    text: 'Lead ushbu clientga biriktirilmagan'
  },
  1748: {
    key: 'leadAttachedToClient',
    text: 'Lead clientga biriktirilgan!'
  },
  1749: {
    key: 'leadDoesNotTask',
    text: 'Lead ga topshiriq biriktirilmagan!'
  },
  1750: {
    key: 'pipeStatusCannotBeDeleted',
    text: "Ushbu statusni o'chirish mumkin emas!"
  },
  1751: {
    key: 'reasonsForRefusalNotFound',
    text: 'Rad etish sabablari topilmadi!'
  },
  1752: {
    key: 'reasonsForRefusalUsed',
    text: 'Rad etish sabablari ishlatilgan!'
  },
  1753: {
    key: 'reasonsForRefusalOrdersException',
    text: 'Rad etish sabablari tartibi xato!'
  },
  1754: {
    key: 'planFactPipeStatusNotFound',
    text: 'Plan fact varonka statuslari topilmadi!'
  },
  1755: {
    key: 'planFactPipeNotFound',
    text: 'Plan fact  topilmadi!'
  },
  1756: {
    key: 'planFactCostNotFound',
    text: 'Plan fact xarajatlari topilmadi!'
  },
  1757: {
    key: 'planFactPipeAlreadyExist',
    text: 'Plan fact allaqachon mavjud!'
  },
  1801: {
    key: 'crmRoleUsedException',
    text: 'CRM rol ishlatilgan!'
  },
  1802: {
    key: 'crmRoleNameExistException',
    text: 'Crm rol nomi mavjud!'
  },
  1803: {
    key: 'crmRoleNotFoundException',
    text: 'CRM rol topilmadi!'
  },
  1804: {
    key: 'tagCreateNotAllowed',
    text: 'Teg yaratish uchun sizda ruxsat yuq!'
  },
  1901: {
    key: 'companyTokenForWebsiteNotFound',
    text: 'Kompaniya vebsayt sozlamalari topilmadi: {{&id&}}'
  },
  1902: {
    key: 'amoCrmServerError',
    text: "AmoCRMda xatolik. Iltimos qayta urinib ko'ring yoki administratsiyaga murojaat qiling."
  },
  1903: {
    key: 'amoCrmSettingsNotFound',
    text: 'AmoCrm sozlamalari yoqilmagan!'
  },
  1904: {
    key: 'merchantUsernameConflict',
    text: 'Bunday Username mavjud!'
  },
  1905: {
    key: 'merchantCashNotFount',
    text: 'Kassa topilmadi!'
  },
  1906: {
    key: 'telegramBotNotFount',
    text: 'Bot topilmadi!'
  },
  1907: {
    key: 'companyXAuthTokenNotFound',
    text: 'Turar joy majmuasini visual ko`rinishini ko`rishga ruxsat yuq!'
  },
  1908: {
    key: 'telegramId',
    text: "Telegram id bo'sh bo'lmasligi kerak!"
  },
  1909: {
    key: 'telegramOrPhone',
    text: "Telegram id yoki tel raqam bo'sh bo'lmasligi kerak!"
  },
  1910: {
    key: 'reportConfigNotFound',
    text: 'Report Config topilmadi!'
  },
  1911: {
    key: 'reportConfigTypeExist',
    text: 'Bu {{&name&}} allaqachon mavjud!'
  },
  1912: {
    key: 'crmLeadEdit',
    text: 'Boshqa hodimga biriktirilgan lidni tahrirlashga ruxsat mavjud emas!'
  },
  1913: {
    key: 'onesConfigAlreadyExistExc',
    text: '1C konfigratsiya allaqachon mavjud'
  },
  1914: {
    key: 'onesConfigNotFound',
    text: '1C konfigratsiya topilmadi'
  },
  1915: {
    key: 'onesInvalidKey',
    text: "Mos bo'lmagan key"
  },
  1916: {
    key: 'notificationNotFound',
    text: 'Bildirishnoma topilmadi!'
  },
  1917: {
    key: 'notifyConfigNotFound',
    text: 'Bildirishnoma sozlamasi topilmadi!'
  },
  1918: {
    key: 'telegramChatBotConfigNotFound',
    text: 'Bot konfigratsiyasi topilmadi!'
  },
  1919: {
    key: 'telegramChatBotUserNotFound',
    text: 'Telegram bot foydalanuvchisi topilmadi!'
  },
  1920: {
    key: 'embedWidgetConfigAlreadyExistExc',
    text: 'Embed vidget konfigratsiya allaqachon mavjud'
  },
  1921: {
    key: 'smsBotConfigNotFoundExc',
    text: 'SMS Bot konfiguratsiyasi topilmadi'
  },
  1922: {
    key: 'brojectConfigNotFound',
    text: 'Broject Config topilmadi!'
  },
  1923: {
    key: 'brojectConfigAlreadyExistsExc',
    text: 'Broject konfigratsiya allaqachon mavjud'
  },
  1924: {
    key: 'amoCrmCompanyConfigsNotFound',
    text: 'AmoCrm uchun kompaniya sozlamalari mavjud emas!'
  },
  1925: {
    key: 'telegramAndWebsiteNotFound',
    text: "Website va telegram botdan kelgan murojatlarni yo'naltirish sozlamasi topilmadi!"
  },
  1926: {
    key: 'moiZvonkiWebhookSebscribeException',
    text: "Мои Звонки bilan bog'lanishda muommo bo'ldi.Iltimos qayta urunib ko'ring"
  },
  1927: {
    key: 'moiZvoniEmployeeNotFound',
    text: 'Мои Звонки tizimidan xodim topilmadi!'
  },
  1928: {
    key: 'moiZvonkiCofigsNotFound',
    text: 'Мои Звонки sozlamalari topilmadi!'
  },
  1929: {
    key: 'moiZvonkiSmsSendException',
    text: 'Sms junatishda xatolik!'
  },
  1930: {
    key: 'moiZvonkiMakeCallException',
    text: 'Telefon qilishda xatolik!'
  },
  1931: {
    key: 'moiZvonkismsTempNotFound',
    text: 'Sms shabloni topilmadi!'
  },
  1932: {
    key: 'pbxAuthException',
    text: "OnlinePbx tizimi bilan bog'lanishda xatolik yuzaga keldi , Iltimos ma'lumotlarni to'g'riligini qayta tekshiring!"
  },
  1933: {
    key: 'pbxConfigsNotFound',
    text: 'OnlinePbx sozlamalari topilmadi!'
  },
  1934: {
    key: 'pbxEmployeeNotFound',
    text: 'OnlinePbx foydalanuvchilari topilmadi!'
  },
  1935: {
    key: 'pbxContactNotFoundException',
    text: 'OnlinePbx telefon raqamlari topilmadi!'
  },
  1936: {
    key: 'pbxContactAlreadyExistException',
    text: "Ko'rsatilgan nomerlar boshqa varonkalar uchun sozlangan!"
  },
  1937: {
    key: 'duplicatePbxEmployeeException',
    text: '{{&employeeName&}} ismli xodim boshqa onlinepbx xodimiga biriktirilgan!'
  },
  1938: {
    key: 'sipuniConfigNotFound',
    text: 'Sipuni sozlamalari topilmadi!'
  },
  1939: {
    key: 'sipuniEmployeeNotFound',
    text: 'Sipuni xodimiga biriktirilgan xodim topilmadi!'
  },
  1940: {
    key: 'sipuniContactNotFound',
    text: 'Sipuni telefon nomeri topilmadi!'
  },
  1941: {
    key: 'sipuniCallHandlingNotFound',
    text: "Sipuni qo'ng'iroqlarni boshqarish sozlamalari topilmadi!"
  },
  1942: {
    key: 'sipuniCallHandlingAlreadyExist',
    text: "Ko'rsatilgan nomerlar boshqa varonkalar uchun sozlangan!"
  },
  2001: {
    key: 'taskNotFound',
    text: 'Topshiriq topilmadi!'
  },
  2002: {
    key: 'taskRobotConfigNotFound',
    text: 'Bot sozlamalari topilmadi!'
  },
  2003: {
    key: 'autoTaskSettingNotFound',
    text: 'Robot sozlamalri topilmadi!'
  },
  2004: {
    key: 'crmTaskEdit',
    text: 'Boshqa hodimga biriktirilgan topshiriqni tahrirlashga ruxsat mavjud emas!'
  },
  2005: {
    key: 'pushNotificationConfigNotFoundException',
    text: 'Push bildirishnoma konfiguratsiyasi topilmadi'
  },
  2006: {
    key: 'pushNotificationConfigPartNotFoundException',
    text: 'Push konfiguratsiya sozlamasi topilmadi'
  },
  2007: {
    key: 'pushNotificationIsNotAllowedException',
    text: 'Push bildirishnomalarga ruxsat berilmagan'
  },
  2008: {
    key: 'duplicateStatusExceptions',
    text: 'Bir turdagi konfiguratsiya takrorlanmoqda'
  },
  2009: {
    key: 'googleAccountAlreadyConnected',
    text: 'Google akkaunt oldin ulangan!'
  },
  2010: {
    key: 'googleEmailExists',
    text: 'Ushbu email oldin ulangan!'
  },
  2011: {
    key: 'brojectConfigRequired',
    text: 'Broject sozlamasi kiritilmagan!'
  },
  2012: {
    key: 'telegramAccountNotFoundException',
    text: 'Telegram akkaunt topilmadi!'
  },
  2013: {
    key: 'telegramAccountAlreadyExistsException',
    text: 'Telegram akkaunt allaqachon mavjud!'
  },
  2014: {
    key: 'taskTypeAlreadyUsedMessage',
    text: 'Topshiriq turi topshiriqda foydalanilgan!'
  },
  2015: {
    key: 'leadTaskTypeNotFound',
    text: 'Vazifa turi topilmadi!'
  },
  2101: {
    key: 'fileTypeMisMatch',
    text: 'Fayl turi tog`ri kelmadi!'
  },
  2102: {
    key: 'campaignNotFound',
    text: 'Toplam topilmadi!'
  },
  2103: {
    key: 'channelNotFound',
    text: 'SIP topilmadi!'
  },
  2104: {
    key: 'channelCreateException',
    text: 'SIP yaratishda xatolik!'
  },
  2105: {
    key: 'campaignNotCancelledException',
    text: "To'plamni bekor qilishda xatolik!"
  },
  2106: {
    key: 'campaignNotPausedException',
    text: 'To‘plamni pauza qilishda xatolik!'
  },
  2107: {
    key: 'campaignNotResumedException',
    text: "To'plamni davom ettirishda xatolik!"
  },
  2201: {
    key: 'bookingDelayInvalidException',
    text: "Buyurtma muddati noto'g'ri kiritilgan!"
  },
  2202: {
    key: 'bookingMinPriceInvalidException',
    text: "Buyurtma to'lovi noto'g'ri kiritilgan!"
  },
  2203: {
    key: 'bookingCancelReasonNotFound',
    text: 'Buyurtmani bekor qilish sababi tanlanmagan!'
  },
  2204: {
    key: 'bookingAlreadyExists',
    text: 'Xonadonga boshqa buyurtma mavjud!'
  },
  2205: {
    key: 'bookingConlict',
    text: 'Booking ni bekor qilishlik uchun prePayment miqdori yetarli emas'
  },
  2206: {
    key: 'bookingDelayExceeded',
    text: 'Buyurtma kuni belgilangan cheklovdan oshib ketdi.Chegara {{&limit&}}'
  },
  2207: {
    key: 'bookingNotFound',
    text: 'Buyurtma topilmadi!'
  },
  2301: {
    key: 'unknownClientType',
    text: "Mijoz ma'lumotida xatolik. Iltimos Administratsiyaga murojaat qiling!"
  },
  2302: {
    key: 'clientDoesNotAttachedLead',
    text: "Mijozga lead bog'lanmagan, Iltimos avval leadni biriktiring"
  },
  2303: {
    key: 'insufficientClientBalance',
    text: "Mijoz balansida mablag' yetarli emas!"
  },
  2304: {
    key: 'clientInvalidData',
    text: "Mijoz ma'lumotlarida xatolik mavjud!"
  },
  2305: {
    key: 'clientNotFound',
    text: 'Mijoz topilmadi!'
  },
  2306: {
    key: 'noActivePhone',
    text: 'Activ nomer tanlanmagan!'
  },
  2307: {
    key: 'duplicateActivePhone',
    text: 'Ikkita aktiv nomer tanlangan!'
  },
  2401: {
    key: 'districtNotFound',
    text: "Siz ko'rsatgan tuman mavjud emas. Iltimos, qayta urinib ko'ring, yoki administratorga murojaat qiling!"
  },
  2402: {
    key: 'countryNotFound',
    text: "Siz ko'rsatgan mamlakat mavjud emas. Iltimos, qayta urinib ko'ring, yoki administratorga murojaat qiling!"
  },
  2403: {
    key: 'cityNotSelected',
    text: 'Shahar tanlanmagan'
  },
  2404: {
    key: 'districtNotSelected',
    text: 'Tuman tanlanmagan'
  },
  2501: {
    key: 'defaultOriginatorAdded',
    text: 'Bu originator avtomatik tanlaniladi'
  },
  2502: {
    key: 'defaultOriginatorEskizAdded',
    text: 'Bu Eskiz originator avtomatik tanlaniladi'
  },
  2503: {
    key: 'playMobileTestFailed',
    text: "Xizmat topilmadi yoki internet bilan aloqa yo'q"
  },
  2504: {
    key: 'originatorNotFound',
    text: 'Originator topilmadi'
  },
  2505: {
    key: 'originatorEskizNotFound',
    text: 'Originator Eskiz topilmadi'
  },
  2506: {
    key: 'originatorExist',
    text: 'Originator mavjud'
  },
  2507: {
    key: 'originatorEskizExist',
    text: 'Originator Eskiz mavjud'
  },
  2508: {
    key: 'playMobileConfNotFound',
    text: 'Play mobile sozlamalari topilmadi'
  },
  2509: {
    key: 'eskizConfNotFound',
    text: 'Eskiz sozlamalari topilmadi'
  },
  2510: {
    key: 'messageServiceNotActivated',
    text: 'Xabar xizmati yoqilmagan!'
  },
  2511: {
    key: 'smsNotFound',
    text: 'Sms topilmadi!'
  },
  2512: {
    key: 'isNotDeleted',
    text: "O'chirib yuborish mumkin emas!"
  },
  2513: {
    key: 'smsTimeConflictException',
    text: 'Faqat bitta vaqt kiritish usulidan foydalanish mumkin!'
  },
  2514: {
    key: 'smsConfigsNotFound',
    text: 'Sms sozlamalari topilmadi'
  },
  2601: {
    key: 'noPermissionToEditDashboard',
    text: "Asosiy dashboardni o'zgartirishga ruhsat yo'q!"
  },
  2602: {
    key: 'dashboardNotFound',
    text: 'Dashboard topilmadi!'
  },
  2603: {
    key: 'dashboardNameExist',
    text: 'Dashboard nomi allaqachon mavjud!'
  },
  2604: {
    key: 'widgetNameExist',
    text: 'Widget nomi allaqachon mavjud!'
  },
  2605: {
    key: 'widgetNotFound',
    text: 'Widget topilmadi!'
  },
  2606: {
    key: 'widgedLimit',
    text: 'Boshqaruv paneli chegarasi 16!'
  },
  2607: {
    key: 'deleteMainDashboard',
    text: "Asosiy dashboardni o'chira olmaysiz!"
  },
  2701: {
    key: 'employeeNotFound',
    text: 'Xodim topilmadi!'
  },
  2702: {
    key: 'invalidPassword',
    text: 'Parol xato!'
  },
  2703: {
    key: 'employeeUsernameExist',
    text: 'Username allaqachon mavjud!'
  },
  2704: {
    key: 'customTemplateExist',
    text: 'Bu nomdagi shablon nomi mavjud: {{&name&}}'
  },
  2705: {
    key: 'companyCustomTempNotFound',
    text: 'Custom shablon topilmadi!'
  },
  2706: {
    key: 'companyConfigAlreadyExists',
    text: 'Kompaniya sozlamasi mavjud!'
  },
  2707: {
    key: 'companyConfigNotFound',
    text: 'Kompaniya sozlamasi topilmadi!'
  },
  2709: {
    key: 'companyDisabled',
    text: 'Kompaniya bloklangan'
  },
  2710: {
    key: 'configInvalidPattern',
    text: 'Birlamchi andozada xatolik!'
  },
  2711: {
    key: 'companyNameAlreadyExists',
    text: "Bu nomdagi '{{&name&}}' kompaniya mavjud"
  },
  2712: {
    key: 'templateInvalid',
    text: 'Shablonda xatolik mavjud!'
  },
  2713: {
    key: 'companyAlreadyGetExtraDay',
    text: "Kompaniya allaqachon qo'shimcha kun olgan"
  },
  2714: {
    key: 'noPermissionToAddExtraDay',
    text: "Huquq yo'q, Kampaniyangiz adminstratoriga murojaat qiling"
  },
  2715: {
    key: 'companyBlocked',
    text: 'Litsenziya muddati tugaganligi sababli hisobingiz bloklandi!'
  },
  2716: {
    key: 'companyNotFound',
    text: 'Kompaniya topilmadi.'
  },
  2717: {
    key: 'employeeExists',
    text: 'Bunday xodim mavjud'
  },
  2718: {
    key: 'employeeWithThisNameExists',
    text: 'Bunday ismli xodim mavjud'
  },
  2801: {
    key: 'licenseSmsConfigNotFound',
    text: 'Litsenziya Sms sozlamasi topilmadi!'
  },
  2802: {
    key: 'licenseSmsConfigAlreadyExistsExc',
    text: 'Litsenziya Sms sozlamasi allaqachon mavjud'
  },
  2803: {
    key: 'sendVerifyCodeError',
    text: '{{&number&}} nomeriga tasdiqlash kodi junatishda xatolik!'
  },
  2804: {
    key: 'verifyCodeIncorrect',
    text: "Tasdiqlash kodi noto'g'ri kiritildi"
  },
  2901: {
    key: 'branchNotFound',
    text: 'Filial topilmadi!'
  },
  2902: {
    key: 'branchIsNotAllowed',
    text: "Fililalga ruxsat yo'q!"
  },
  2903: {
    key: 'branchUseOnRoleBranchException',
    text: 'Ushbu filialda xodimlar mavjud!!!'
  },
  3001: {
    key: 'staffNotFound',
    text: 'Hodim topilmadi!'
  },
  3002: {
    key: 'companyEmployeKpiSettingNotFound',
    text: 'Kompaniya KPI sozalamalari topilmadi!'
  },
  3003: {
    key: 'bothKpiCannotActive',
    text: "Ikkala KPI hisoblash tizimi bir vaqtda aktiv bo'lishi mumkin emas!"
  },
  3004: {
    key: 'employeePaymentAmountInvalid',
    text: 'Kiritilgan summa hodim balansida mavjud emas!'
  },
  3005: {
    key: 'staffBalanceNotFoundExc',
    text: 'Xodim balansi topilmadi'
  },
  3101: {
    key: 'remoteSessionNotFound',
    text: 'Sessiya topilmadi!'
  },
  3102: {
    key: 'wrongRemoteSessionStatus',
    text: 'Sessiya statusi nomaqbul holatda!'
  },
  3103: {
    key: 'roleIsUsed',
    text: 'Ushbu roldagi hodimlar mavjud!'
  },
  3104: {
    key: 'companyPermissionNotFound',
    text: 'Kompaniya ruxsat sozlamalari topilmadi!'
  },
  3105: {
    key: 'permissionNotFound',
    text: 'Ruxsat topilmadi!'
  },
  3106: {
    key: 'crmAccessDeniedException',
    text: 'Ruxsat mavjud emas!'
  },
  3107: {
    key: 'roleBranchConflictException',
    text: "Barcha filiallar uchun bir nechta rol bo'lishi mumkin emas!!!"
  },
  3108: {
    key: 'onlyRoleTheBranch',
    text: "Bir fililaga faqat bitta rol bo'lishi mumkin!!!"
  },
  3109: {
    key: 'userDisabled',
    text: 'Foydalanuvchi bloklangan'
  },
  3110: {
    key: 'roleNotFound',
    text: 'Role topilmadi'
  },
  3111: {
    key: 'roleAlreadyExist',
    text: 'Bu nomdagi rol avval yaratilgan'
  },
  3112: {
    key: 'refreshTokenExpired',
    text: "Sessiya muddati o'tgan"
  },
  3113: {
    key: 'refreshTokenNotFound',
    text: 'Refresh token topilmadi'
  },
  3114: {
    key: 'invalidCaptcha',
    text: 'reCAPTCHA javobi noto‘g‘ri!'
  },
  3115: {
    key: 'roleNotUpdatePermission',
    text: 'Role ruxsatlarini boshqarish imkoni yuq!'
  },
  3116: {
    key: 'roleLimit',
    text: 'Role yaratishda maksimal qiymati : {{&count&}}'
  },
  3117: {
    key: 'passwordMismatch',
    text: 'Parol xato kiritilgan'
  },
  3118: {
    key: 'passwordNotStrong',
    text: 'Siz kiritgan parol yetarli darajada kuchli emas!'
  },
  3119: {
    key: 'userNotFound',
    text: 'Bunday foydalanuvchi topilmadi'
  },
  3120: {
    key: 'activeSessionNotFound',
    text: 'Faol seans topilmadi!'
  },
  3121: {
    key: 'loginFailed',
    text: "Login yoki parol noto'g'ri!"
  },
  3201: {
    key: 'dataTransferTypeMismatch',
    text: "Fayl '{{&sheetName&}}'ning {{&cellName&}}-katakchasida xatolik mavjud."
  },
  3202: {
    key: 'excelElementsCount',
    text: "Ma'lumotlar soni juda ko'p. Maksimal elementlar soni: 5000"
  },
  3302: {
    key: 'marketplaceConfigNotFound',
    text: 'Marketplace sozlamalari topilmadi'
  },
  3303: {
    key: 'marketplaceNotIntegrated',
    text: 'Uysot.uz online uy bozori aktivlashtirilmagan!'
  },
  3401: {
    key: 'fileNotFound',
    text: 'Fayl topilmadi!'
  },
  3402: {
    key: 'fileSizeLimitReached',
    text: 'Fayl hajmi juda katta! (cheklov:{{&limit&}}MB)'
  },
  3601: {
    key: 'currencyNotFound',
    text: 'Valyuta topilmadi!'
  },
  3602: {
    key: 'currencyLimit',
    text: 'Ikkidan ortiq valyuta kiritish mumkin emas!'
  },
  3603: {
    key: 'basicCurrencyNotModified',
    text: "Asosiy valyuta ustida amal bajarib bo'lmaydi!"
  },
  3604: {
    key: 'basicCurrencyNotFound',
    text: 'Asosiy valyuta topilmadi!'
  },
  3701: {
    key: 'accessDenied',
    text: "Huquq yo'q!"
  },
  3702: {
    key: 'httpClientError',
    text: '{{&message&}}'
  },
  3704: {
    key: 'systemError',
    text: "Tizimda xatolik, iltimos qayta urinib ko'ring yoki administratsiyaga murojaat qiling!"
  },
  3705: {
    key: 'badRequest',
    text: "So'rovda xatolik"
  },
  3801: {
    key: 'smartCatalogConfigNotFound',
    text: 'Sozlamalar topilmadi!'
  },
  3901: {
    key: 'excelConstructorTemplateNotFoundExceptions',
    text: 'Excel konstruktor shabloni topilmadi'
  },
  4001: {
    key: 'wordlinUnknownOperator',
    text: "Faylda noma'lum operator qo'llanilingan, iltimos shablonni ko'rib chiqing!"
  },
  4002: {
    key: 'wordlinCorruptedInput',
    text: "Faylni yaratishda xatolik mavjud. Iltimos qayta urinib ko'ring yoki administratorga murojaat qilingiz."
  },
  4101: {
    key: 'realtorConfigNotFound',
    text: 'Showroom sozlamalari topilmadi!'
  },
  4102: {
    key: 'realtorNotActive',
    text: "Kiritilgan login va parol aktiv holatda emas yoki noto'g'ri kiritilgan!"
  },
  4103: {
    key: 'failedBookingFromRealtor',
    text: 'Buyurtma bilan muommo yuzaga keldi!'
  },
  4104: {
    key: 'noPermissionToCancelBooking',
    text: 'Buyurtmani bekor qilishga ruxsat yuq!'
  },
  4105: {
    key: 'noPermissionToCreateBooking',
    text: 'Buyurtmani bekor qilishga ruxsat yuq!'
  },
  2308: {
    key: 'clientHasContract',
    text: "Mijozni o'chirib bo'lmaydi!Mijozni shartnomasi mavjud!"
  },
  2309: {
    key: 'clientHasBooking',
    text: "Mijozni o'chirib bo'lmaydi!Mijozni buyurtmasi mavjud!"
  },
  2310: {
    key: 'clientHasLead',
    text: "Mijozni o'chirib bo'lmaydi!Mijozni lidi mavjud!!"
  },
  2311: {
    key: 'clientHasLeadTask',
    text: "Mijozni o'chirib bo'lmaydi! Mijozni topshirig'i mavjud!!"
  },
  2312: {
    key: 'clientHasPayment',
    text: "Mijozni o'chirib bo'lmaydi! Mijoz to'lov qilgan!"
  },
  2016: {
    key: 'telegramBotTokenInvalidException',
    text: 'Telegram bot tokeni yaroqsiz'
  },
  1758: {
    key: 'facebookTokenExpired',
    text: 'Facebook tokeni yaroqsiz!'
  },
  1759: {
    key: 'customFieldIsNotMultiSelectExceptions',
    text: 'Custom field multi select emas!'
  },
  1323: {
    key: 'repairedFlatInvalidField',
    text: "Ta'mirli xonadonning ta'mirli narxi kiritilmagan, raqami: {{&flatNumber&}}, parametr: {{&field&}}"
  },
  8000: {
    key: 'grpcError',
    text: 'Grpc xatolik'
  },
  8001: {
    key: 'tokenWrong',
    text: 'Bot tokeni xato'
  },
  8002: {
    key: 'businessConnectionNotFound',
    text: 'Bunday telgram ulanishi mavjud emas!'
  },
  8003: {
    key: 'invalidUrl',
    text: 'webhook urli xato!'
  },
  8004: {
    key: 'chatNotFound',
    text: 'Chat topilmadi'
  },
  8005: {
    key: 'conflictWithTelegram',
    text: "Tizimda xatolik, iltimos qayta urinib ko'ring yoki administratsiyaga murojaat qiling!"
  },
  2017: {
    key: 'taskRobotBuildingEmployeeNodesConflictException',
    text: 'Xodim va Blokni qayta tanlash mumkin emas'
  },
  2719: {
    key: 'departmentNotFoundException',
    text: "Bo'lim topilmadi!"
  },
  2720: {
    key: 'departmentHasEmployeesException',
    text: "Bo'limda xodimlar mavjud!"
  },
  2721: {
    key: 'departmentNameExistsException',
    text: "Bunday bo'lim nomi mavjud!"
  },
  4200: { key: 'cashbackConfigNotFound', text: 'Keshbek sozlamasi topilmadi' },
  4201: { key: 'cashbackConfigPartNotFound', text: 'Keshbek qism sozlamasi topilmadi' },
  4202: { key: 'cashbackBalanceNotFound', text: 'Keshbek balansi topilmadi' },
  4203: { key: 'insufficientFundsAvailable', text: "Balansda mablag' yetarli emas" },
  1324: { key: 'flatAlreadySelected', text: 'Xonadon allaqachon biriktirilgan' },
  4106: { key: 'realtorBookingNotFound', text: "Buyurtma yaratish uchun so'rov topilmadi!" },
  4107: { key: 'forbiddenCompanyException', text: 'Ushbu kompaniyaga ruxsat yoq!' },
  4108: { key: 'requiredField', text: "Majburiy o'zgaruvchi {{&requiredField&}} to'ldirilmagan" },
  4113: { key: 'realtorNotFound', text: 'Realtor topilmadi!' },
  4109: { key: 'offerNotFound', text: 'Taklif topilmadi!' },
  4110: { key: 'offerDoesNotDelete', text: "Ushbu statusda 'Taklif' larni o'chirish mumkin emas!!!" },
  4111: { key: 'offerDoesNotUpdate', text: "Ushbu statusda 'Taklif' larni tahrirlash mumkin emas!!!" },
  4112: { key: 'offerPaymentNotFound', text: "Taklif to'lovi topilmadi!" },
  1325: {
    key: 'flatHasBooking',
    text: "Xonadonni o'chirib bo'lmaydi, Xonadonni buyurtmasi bor, raqami: {{&number&}}"
  },
  1326: {
    key: 'flatHasContract',
    text: "Xonadonni o'chirib bo'lmaydi,Xonadonni shartnomasi bor, raqami: {{&number&}}"
  },
  1327: {
    key: 'flatConnectedToLead',
    text: "Xonadonni o'chirib bo'lmaydi,Xonadon lidga bog'langan, raqami: {{&number&}}"
  },
  1123: {
    key: 'balancePaymentNotDelete',
    text: "Balansga qilinga to'lovni o'chirib bo'lmaydi!"
  },
  3503: {
    key: 'onceTheProcessIscompleteitCannotBeUndone',
    text: "Jarayon tugallangandan so'ng ortga qaytarib bo'lmaydi !"
  },
  1943: { key: 'driveConfigNotFound', text: 'Sozlamalar topilmadi' },
  1944: { key: 'driveAccountNotFound', text: 'Akkaunt topilmadi' },
  1945: { key: 'driveFileExists', text: 'Ushbu fayl oldin ulangan' },
  1946: { key: 'driveConfigHasDuplicateFields', text: 'Ushbu ustun sozlangan' },
  1760: { key: 'cannotSaveLeadWithoutReason', text: "Leadni sababsiz saqlab bo'lmaydi!" },
  1761: { key: 'reasonsForRefusalLimitExceeded', text: 'Rad etish sabablarining limiti oshib ketdi!' },
  1762: { key: 'leadDoesNotSelect', text: 'Lead tanlanmagan' },
  4600: { key: 'audioAnalyzerNotFound', text: 'Audio analyse topilmadi' },
  4601: { key: 'callAnalysisLimitExceeded', text: "Qo'ng'iroq tahlil qilish limitdan oshgan" },
  1044: { key: 'CONTRACT_AMOUNT_MISMATCH', text: 'Shartnoma summasi mos kelmadi!' },
  1763: { key: 'CALL_EVALUATION_NOT_FOUND', text: "Qo'ng'iroq baholash sozlamalari topilmadi!" },
  1764: { key: 'CALL_EVALUATION_CONFIG_NOT_FOUND', text: "Qo'ng'iroq baholari topilmadi!" },
  1765: { key: 'CALL_DURATION_MISMATCH', text: "Qo'ng'iroq davomiyligi to'gri tushmaydi!" },
  2313: { key: 'clientJSHSHIRNotInfo', text: "Mijozning JSHSHIR(INN) ma'lumotlari kiritilmagan" },
  4700: { key: 'onlineContractConfigNotFound', text: 'Onlayn shartnoma konfiguratsiyasi topilmadi' },
  4701: { key: 'clientSignedInfoNotFound', text: "Mijoz imzo ma'lumotlari topilmadi" },
  4702: { key: 'clientAlreadySigned', text: 'Mijoz allaqochon imzolagan' },
  4703: { key: 'contractAlreadySigned', text: 'Sharnoma allaqochon imzolangan' },
  4704: { key: 'clientYetNotSigned', text: 'Mijoz hali imzolamagan' },
  4705: { key: 'contractHasPayment', text: "Shartnoma to'lovi mavjud" },
  4706: { key: 'contractNotFirstPaymentZero', text: "Shartnoma boshlang'ich to'lov nolga teng bo'lmasligi kerak" },
  4707: { key: 'contractAlreadyOnlineSigned', text: 'Sharnoma allaqachon onlayn imzolangan' },
  4708: { key: 'localCurrencyNotFound', text: 'Mahalliy valyuta topilmadi' },
  4750: { key: 'BDMConfigNotFound', text: 'BDM konfiguratsiya topilmadi' },
  4751: { key: 'BDMNotActivated', text: 'BDM faollashtirilmagan' },
  4752: { key: 'BdmRefreshTokenExpired', text: 'Bdm refresh token eskirgan' },
  4753: { key: 'BdmSystemError', text: 'Bdm tizimida xatolik' },
  1047: { key: 'PREPAYMENT_PARTS_DATE_CONFLICT', text: "Boshlang'ich to'lov qisimlar sanasi mos emas" },
  5000: { key: 'nikitaConnectServerError', text: 'Nikita serverga ulanishda xatolik mavjud!' },
  5001: { key: 'errorInRequestFormat', text: "So'rov formatida xato" },
  5002: { key: 'invalidateAuthorization', text: 'Yaroqsiz avtorizatsiya' },
  5003: { key: 'senderIPAddressInvalid', text: "Yuboruvchining IP manzili noto'g'ri" },
  5004: { key: 'insufficientFundsClientAccount', text: "Mijoz hisobidagi mablag' yetarli emas" },
  5005: { key: 'invalidSenderName', text: "Yuboruvchi nomi noto'g'ri" },
  5006: { key: 'messageBlockedWithStopWords', text: "Xabar to'xtash so'zlari bilan bloklangan" },
  5007: {
    key: 'oneOrMoreRecipientNumbersMisspelled',
    text: "Bir yoki bir nechta qabul qiluvchi telefon raqamlarining noto'g'ri yozilishi"
  },
  5008: { key: 'requestProcessingTimeHasExpired', text: "So'rovni ko'rib chiqish muddati oshib ketdi" },
  5009: {
    key: 'submissionBlockedDueRepeatedIdentifier',
    text: 'Identifikatorning ketma-ket takrorlanishi tufayli yuborish bloklandi'
  },
  4801: { key: 'CHAT_FLOW_NOT_FOUND', text: 'Chat oqimi topilmadi' },
  4802: { key: 'BLOCK_NOT_FOUND', text: 'Blok topilmadi.' },
  4803: { key: 'BLOCK_OPTION_NOT_FOUND', text: 'Blokdagi javob topilmadi.' },
  4804: { key: 'CHAT_FLOW_TYPE_MIS_MATCH', text: 'Chat oqim turi mos emas!' },
  4805: { key: 'CHAT_FLOW_BLOCK_STRUCTURE_ERROR', text: 'Chat oqim bloklarida xatolik majvud!' },
  4806: { key: 'BLOCK_OPTION_IS_REQUIRED', text: 'Blokdagi javob majburiy.' }
};
